<!-- ========== Left Sidebar Start ========== -->
<div class="vertical-menu">
  <ngx-simplebar class="h-100 sidebar-menu" #componentRef>
    <div id="sidebar-menu">
      <ul class="metismenu list-unstyled" id="side-menu" #sideMenu>
        @for (item of menuItems; track item.id) {
          <li>
            @if (hasItems(item)) {
              <a
                href="javascript:void(0);"
                class="is-parent"
                [ngClass]="{ 'has-arrow': !item.badge, 'has-dropdown': item.badge }"
              >
                @if (item.icon) {
                  <i class="bx {{ item.icon }}"></i>
                }
                <span>{{ item.label | translate }}</span>
                @if (item.badge) {
                  <span class="badge rounded-pill float-end bg-{{ item.badge.variant }}">
                    {{ item.badge.text | translate }}
                  </span>
                }
              </a>
            } @else if (item.isExternal) {
              <!-- An admin-authored link leaves the app, so it is a plain href: routerLink would
                   try to resolve the absolute URL as a route. It carries no `side-nav-link-ref`
                   either — active-route matching reads that class as an in-app path. -->
              <a
                [href]="item.link"
                class="side-nav-external-link-ref"
                [attr.target]="item.openInNewTab === false ? null : '_blank'"
                [attr.rel]="item.openInNewTab === false ? null : 'noopener noreferrer'"
              >
                @if (item.icon) {
                  <i class="bx {{ item.icon }}"></i>
                }
                <span>{{ item.label | translate }}</span>
              </a>
            } @else {
              <a
                [routerLink]="item.link"
                class="side-nav-link-ref"
                [attr.data-active-paths]="item.activePaths?.join(',')"
                routerLinkActive="active"
              >
                @if (item.icon) {
                  <i class="bx {{ item.icon }}"></i>
                }
                <span>{{ item.label | translate }}</span>
                @if (item.badge) {
                  <span class="badge rounded-pill float-end bg-{{ item.badge.variant }}">
                    {{ item.badge.text | translate }}
                  </span>
                }
                @if (pendingBadge(item); as count) {
                  <span class="badge rounded-pill float-end bg-danger">{{ count }}</span>
                }
              </a>
            }

            @if (hasItems(item)) {
              <ul class="sub-menu">
                @for (subitem of item.subItems; track subitem.id) {
                  <li>
                    @if (hasItems(subitem)) {
                      <a
                        href="javascript:void(0);"
                        class="side-nav-link-a-ref has-arrow"
                        [attr.data-parent]="subitem.parentId"
                      >
                        {{ subitem.label | translate }}
                      </a>
                      <ul class="sub-menu mm-collapse">
                        @for (subSubitem of subitem.subItems; track subSubitem.id) {
                          <li>
                            @if (subSubitem.isExternal) {
                              <a
                                [href]="subSubitem.link"
                                [attr.data-parent]="subSubitem.parentId"
                                [attr.target]="subSubitem.openInNewTab === false ? null : '_blank'"
                                [attr.rel]="
                                  subSubitem.openInNewTab === false ? null : 'noopener noreferrer'
                                "
                                class="side-nav-external-link-ref"
                                [class.pending-badge-link]="pendingBadge(subSubitem)"
                              >
                                {{ subSubitem.label | translate }}
                                @if (pendingBadge(subSubitem); as count) {
                                  <span class="badge rounded-pill float-end bg-danger">{{
                                    count
                                  }}</span>
                                }
                              </a>
                            } @else {
                              <a
                                [routerLink]="subSubitem.link"
                                [attr.data-parent]="subSubitem.parentId"
                                [attr.data-active-paths]="subSubitem.activePaths?.join(',')"
                                routerLinkActive="active"
                                class="side-nav-link-ref"
                              >
                                {{ subSubitem.label | translate }}
                              </a>
                            }
                          </li>
                        }
                      </ul>
                    } @else if (subitem.isExternal) {
                      <a
                        [href]="subitem.link"
                        class="side-nav-external-link-ref"
                        [attr.data-parent]="subitem.parentId"
                        [attr.target]="subitem.openInNewTab === false ? null : '_blank'"
                        [attr.rel]="subitem.openInNewTab === false ? null : 'noopener noreferrer'"
                      >
                        {{ subitem.label | translate }}
                      </a>
                    } @else {
                      <a
                        [routerLink]="subitem.link"
                        class="side-nav-link-ref"
                        [attr.data-parent]="subitem.parentId"
                        [attr.data-active-paths]="subitem.activePaths?.join(',')"
                        [class.pending-badge-link]="pendingBadge(subitem)"
                        routerLinkActive="active"
                      >
                        {{ subitem.label | translate }}
                        @if (subitem.badge) {
                          <span class="badge rounded-pill float-end bg-{{ subitem.badge.variant }}">
                            {{ subitem.badge.text | translate }}
                          </span>
                        }
                        @if (pendingBadge(subitem); as count) {
                          <span class="badge rounded-pill float-end bg-danger">{{ count }}</span>
                        }
                      </a>
                    }
                  </li>
                }
              </ul>
            }
          </li>
        }
      </ul>
    </div>
  </ngx-simplebar>
</div>
<!-- Left Sidebar End -->
